/**
 * Phase 10 — structured conflict envelope. The API returns `409` with
 * this shape whenever a queued mutation can no longer apply cleanly
 * (state moved, entity deleted, schema changed, permission revoked).
 *
 * The shape mirrors what `apps/api/src/lib/conflict.ts` emits so the
 * frontend can render a useful diff in `/sync/conflicts`.
 */
export type ConflictKind =
  | 'stale_inspection'
  | 'wo_state_disallows'
  | 'deleted_entity'
  | 'schema_changed'
  | 'permission_revoked';

export interface ConflictPayload {
  error: 'conflict';
  kind: ConflictKind;
  message: string;
  currentServerState?: Record<string, unknown> | null;
  yourPendingChange?: Record<string, unknown> | null;
}

export function isConflictPayload(value: unknown): value is ConflictPayload {
  if (!value || typeof value !== 'object') return false;
  const v = value as { error?: unknown; kind?: unknown };
  return v.error === 'conflict' && typeof v.kind === 'string';
}
